import { useTranslation } from "react-i18next";
import "../../locales/i18n";
import { Button, Dropdown } from "antd";
import { DownOutlined, GlobalOutlined } from "@ant-design/icons";
import type { MenuProps } from 'antd';

interface LanguageSwitcherProps {
  showLanguageCode?: boolean;
  showDropdownIcon?: boolean;
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  showLanguageCode = true,
  showDropdownIcon = true,
}) => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const languageMenuProps: MenuProps = {
    onClick: ({ key }) => changeLanguage(key),
    items: [
      { key: "sq", label: "Albanian" },
      { key: "en", label: "English" },
    ],
  };

  const buttonStyle = {
    width: 'auto',
    height: '40px',
    padding: '0 10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };


  return (
    <Dropdown menu={languageMenuProps} trigger={['click']}>
      <Button style={buttonStyle}>
        <GlobalOutlined />
        {showLanguageCode && i18n.language.toUpperCase()}{" "}
        {showDropdownIcon && <DownOutlined />}
      </Button>
    </Dropdown>
  );
};